<template>
  <Swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="0"
    :loop="true"
    :grab-cursor="true"
    :speed="600"
    :effect="'fade'"
    :class="$style.swiper"
    class="swiper-fade"
  >
    <SwiperSlide v-for="(image, index) in data" :key="index">
      <Image
        class="aspect-square"
        loading="lazy"
        :src="image.responsiveImage ? image.responsiveImage?.src : image.url"
        :srcset="image.responsiveImage ? image.responsiveImage?.srcSet : undefined"
        :width="image.responsiveImage ? image.responsiveImage?.width : (image.width ?? 400)"
        :height="image.responsiveImage ? image.responsiveImage?.height : (image.height ?? 400)"
        sizes="(min-width: 1400px) 405px, (min-width: 780px) calc(27.67vw + 23px), (min-width: 480px) 406px, 86.25vw"
        :alt="image?.alt ?? ''"
      />
      <div class="text-neutral-70 mt-6 text-sm">
        {{ image.responsiveImage?.title }}
      </div>
    </SwiperSlide>
    <SwiperNav class="absolute bottom-0 right-0 top-auto z-20" />
  </Swiper>
</template>

<script setup lang="ts">
import { EffectFade, Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { FileField } from '~/types/datocms'

import 'swiper/css'
import 'swiper/css/effect-fade'

defineProps({
  data: {
    type: Array as PropType<FileField[]>,
    default: () => []
  }
})

const modules = [EffectFade, Parallax, A11y]
</script>

<style lang="postcss" module>
.swiper {
  @apply relative mx-auto h-auto w-full pb-10;
}
</style>

<style lang="postcss">
.swiper-pagination-bullet {
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-inactive-color: theme('colors.primary.DEFAULT');
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 0;
  --swiper-pagination-bullet-inactive-opacity: 1;
  border-radius: 0;
  margin: 0 2px !important;
}

.swiper-pagination-bullet-active {
  background: theme('colors.black');
}
</style>
